<template>
    <HelpCenterLayout v-bind="helpCenterSharedData.getHelpCenterLayoutProps()">
        <template #hero>
            <HelpCenterHomeHero />
        </template>

        <HomeSectionContainer class="px-6 py-16">
            <div class="grid grid-cols-12 gap-6">
                <div
                    v-for="category in categories"
                    :key="category.slug"
                    class="col-span-12 md:col-span-6 lg:col-span-4"
                >
                    <a :href="category.url">
                        <div
                            class="p-6 rounded-lg bg-white border border-stone-200 shadow-xs hover:border-gray-900 transition ease-linear"
                        >
                            <div class="space-y-4 text-gray-700">
                                <div>
                                    <Icon
                                        name="grid-2"
                                        class="size-6"
                                    />
                                </div>
                                <div class="space-y-2">
                                    <div class="font-semibold">
                                        {{ category.title }}
                                    </div>
                                    <div class="font-light text-sm">
                                        {{ category.description }}
                                    </div>
                                </div>
                                <div class="text-gray-500 text-sm">
                                    {{ category.getArticleCount() }} articles
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </HomeSectionContainer>
    </HelpCenterLayout>
</template>

<script setup lang="ts">
    import HelpCenterHomeHero from '@/HelpCenter/Component/HelpCenterHomeHero.vue'
    import HomeSectionContainer from '@/HelpCenter/Component/HomeSectionContainer.vue'
    import CMSCategory from '@/CMS/Content/Entity/CMSCategory'
    import HelpCenterSharedData from '@/HelpCenter/Entity/HelpCenterSharedData'
    import HelpCenterLayout from '@/HelpCenter/Shared/HelpCenterLayout.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import type {
        CMSCategoryRawData,
        HelpCenterSharedDataRawData,
    } from '@/Shared/AutoGenerated/Main'

    interface HelpCenterShowHomeProps {
        helpCenterSharedDataRawData: HelpCenterSharedDataRawData
        categoriesRawData: CMSCategoryRawData[]
    }

    const props = defineProps<HelpCenterShowHomeProps>()

    const helpCenterSharedData = HelpCenterSharedData.hydrate(
        props.helpCenterSharedDataRawData,
    )
    const categories = CMSCategory.hydrateMultiple(props.categoriesRawData)
</script>
